import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen, Tablet, Star, ShieldCheck } from 'lucide-react';

const TABS = [
  { label: 'Home', path: '/', icon: Home },
  { label: 'Books', path: '/buy', icon: BookOpen },
  { label: 'Read', path: '/read-online', icon: Tablet },
  { label: 'Reviews', path: '/reviews', icon: Star },
  { label: 'Admin', path: '/admin', icon: ShieldCheck },
];

const MobileNav = () => {
  const { pathname } = useLocation();
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-cream/95 backdrop-blur-md border-t border-brand-goldlight shadow-[0_-4px_20px_rgba(0,0,0,0.06)]" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="flex items-stretch justify-around">
        {TABS.map((t) => {
          const active = t.path === '/' ? pathname === '/' : pathname.startsWith(t.path);
          const Icon = t.icon;
          return (
            <Link
              key={t.path}
              to={t.path}
              className="flex-1 flex flex-col items-center gap-0.5 py-2.5 transition-colors"
            >
              <Icon className={`h-5 w-5 ${active ? 'text-brand-brass' : 'text-brand-brown/60'}`} />
              <span className={`text-[10px] font-medium ${active ? 'text-brand-brass' : 'text-brand-brown/60'}`}>
                {t.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
